const useEnvironment = () => {
  const requestOrigin = window.location.origin;
  const prodSubdomainRegEx = /https?:\/\/([a-z0-9]+[.])*seinterminal[.]com/g;
  const stagingSubdomainRegEx = /https?:\/\/([a-z0-9]+[.])*sagetechnologypartners[.]com/g;

  const devSubdomainRegEx = /https?:\/\/([a-z0-9]+[.])*lvh[.]me/g;

  const isProd = prodSubdomainRegEx.test(requestOrigin);
  const isStage = stagingSubdomainRegEx.test(requestOrigin);
  const isDev = devSubdomainRegEx.test(requestOrigin);

  return { isProd, isStage, isDev };
};

export default useEnvironment;
